import { render, staticRenderFns } from "./AttendersSection.vue?vue&type=template&id=0e19dedc&scoped=true&"
import script from "./AttendersSection.vue?vue&type=script&lang=js&"
export * from "./AttendersSection.vue?vue&type=script&lang=js&"
import style0 from "./AttendersSection.vue?vue&type=style&index=0&id=0e19dedc&prod&lang=css&"
import style1 from "./AttendersSection.vue?vue&type=style&index=1&id=0e19dedc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e19dedc",
  null
  
)

export default component.exports